/**
 * Entegrasyon sağlayıcılarının ekranda takma adla gösterilmesi (04.11.2026).
 *
 * Kurulumun ortamında PROVIDER_ALIAS=1 varsa `/settings` yanıtı
 * `provider_alias: true` taşır; sağlayıcılar yalnız **görünen metinde**
 * "Sağlayıcı 1", "Sağlayıcı 2" … olarak yazılır. Anahtarlar, istekler ve
 * sağlayıcının kendi ayar ekranı değişmez.
 *
 * Sıra backend'deki `services/provider_alias.py` → ORDER ile **aynıdır**
 * (backend testi iki listeyi karşılaştırır); yalnız sona ekleme yapılır.
 */
export const PROVIDER_ALIAS_ORDER = [
  'drakon', 'goldpalace', 'oroplay', 'scorpio', 'syncode', 'flexrix',
  'flexcasino', 'flexgis', 'hal9000', 'emsports', 'sportdigi',
  'wizkasa', 'hemensystem', 'hera', 'payurus', 'ultrapay', 'linkhavale',
  'vevopay', 'hizlicaparalar', 'hizlihavale', 'paylux', 'zelvoq',
  'cryptobox',
];

// Serbest metindeki marka yazımları (uzun olan önce).
const NAMES = [
  ['Flexrix Orjinal Casino', 'flexgis'], ['Flexrix Orjinal', 'flexgis'],
  ['Flexrix Casino', 'flexcasino'], ['Flexrix Sportsbook', 'flexrix'],
  ['Flexrix’in', 'flexcasino'], ['Flexrix', 'flexcasino'],
  ['Hemen Havale', 'hemensystem'], ['Link Havale', 'linkhavale'], ['VEVO PAY', 'vevopay'],
  ['HızlıcaParalar', 'hizlicaparalar'], ['Hızlı Havale', 'hizlihavale'],
  ['Wizkasa', 'wizkasa'], ['Payurus', 'payurus'], ['UltraPay', 'ultrapay'],
  ['CryptoBox', 'cryptobox'], ['Paylux', 'paylux'], ['Zelvoq', 'zelvoq'], ['Hera', 'hera'],
];
const escape = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
const NAME_RE = new RegExp(`(?<![/\\w])(${NAMES.map(([n]) => escape(n)).join('|')})(?![\\w])`, 'g');
const NAME_KEY = Object.fromEntries(NAMES.map(([n, k]) => [n, k]));

let enabled = false;

/** SettingsContext ayarlar gelince çağırır. */
export const setProviderAliasEnabled = (value) => { enabled = Boolean(value); };
export const providerAliasEnabled = () => enabled;

export const aliasFor = (key) => {
  const index = PROVIDER_ALIAS_ORDER.indexOf(String(key || '').toLowerCase());
  return index >= 0 ? `Sağlayıcı ${index + 1}` : '';
};

/** Görünen ad: bayrak açıksa takma ad, değilse verilen etiket. */
export const providerName = (key, label) => (enabled && aliasFor(key)) || label;

/** Serbest metindeki marka adlarını takma adla değiştirir (bayrak açıksa). */
export const scrubProviders = (text) => {
  if (!enabled || !text) return text;
  return String(text).replace(NAME_RE, (match) => {
    const alias = aliasFor(NAME_KEY[match]);
    if (!alias) return match;
    return match.endsWith('’in') ? `${alias}’in` : alias;
  });
};

/**
 * Oyuncu metni: oyuncuya "Sağlayıcı 12" demek anlamsızdır, marka tamamen
 * çıkarılır. "X ile Devam Et" → "Ödemeye Devam Et", "X üzerinden işleme
 * alınacaktır" → "işleme alınacaktır", kalan ad → "ödeme sağlayıcısı".
 */
export const scrubForPlayer = (text) => {
  if (!enabled || !text) return text;
  const value = String(text);
  NAME_RE.lastIndex = 0;
  if (!NAME_RE.test(value)) return value;
  NAME_RE.lastIndex = 0;
  if (/ ile Devam Et$/.test(value)) return 'Ödemeye Devam Et';
  const withoutVia = value.replace(new RegExp(` (?:${NAMES.map(([n]) => escape(n)).join('|')}) üzerinden `, 'g'), ' ');
  return withoutVia.replace(NAME_RE, (match, _g, offset) => (
    offset === 0 || /[.;:!?]\s*$/.test(withoutVia.slice(0, offset)) ? 'Ödeme sağlayıcısı' : 'ödeme sağlayıcısı'));
};
